
type CUSTAGAPayload = {
  event_category: string
  event_label: string
}

type RaksulBQPayload = {
  eventName: string
  data: any
}

export const gaEventTracker = (event_name: string, payload: CUSTAGAPayload) => {
  // @ts-ignore
  gtag('event', event_name, payload)
}
const raksulAnalyticSendEvent = (payload: RaksulBQPayload) => {
  // @ts-ignore
  window.raksulDataCollector.sendEvent(payload.eventName, payload.data)
}
const MAX_RETRY_TIME_RAKSUL_TRACKING = 5
export const raksulBQEventTracker = (payload: RaksulBQPayload) => {
  try {
    const events: RaksulBQPayload[] = []
    let retry = 0
    const sendEventInterval = () => {
      const eventInterval = setInterval(() => {
        // @ts-ignore
        if (window.raksulDataCollector) {
          while (events.length) {
            const item = events.pop()
            if (item) raksulAnalyticSendEvent(item)
          }
          clearInterval(eventInterval)
        }
        retry++
        if (retry === MAX_RETRY_TIME_RAKSUL_TRACKING) clearInterval(eventInterval)
      }, 1000)
    }
    // @ts-ignore
    if (window.raksulDataCollector) {
      raksulAnalyticSendEvent(payload)
    } else {
      events.push(payload)
      sendEventInterval()
    }
  } catch (error) {
    throw new Error('raksulBQEventTracker: ' + error)
  }
}

export const EVENT_CATEGORIES = {
  DESIGN_OPTIONS: 'design_options',
  ORDER_FLOW: 'order_flow'
}

export const EVENT_NAMES = {
  OPEN_MODAL: 'open_modal',
  USE_DESIGN_TOOL: 'use_design_tool_product',
  CLICK_UPLOAD_DESIGN: 'start_upload_design_product',
  COMPLETE_UPLOAD_DESIGN: 'complete_upload_design_product',
  FAILED_UPLOAD_DESIGN: 'failed_upload_design',
  ADD_TO_CART: 'add_to_cart',
  ASK_DESIGNER: 'ask_designer',
  CLOSE_MODAL: 'close_modal',
  CLICK_USE_DESIGN_TOOL: 'start_use_design_tool_cart',
  COMPLETE_USE_DESIGN_TOOL: 'complete_use_design_tool_cart',
  EDIT_MY_DESIGN: 'edit_my_design',
  CLICK_UPLOAD_DESIGN_CART: 'click_upload_design_cart',
  COMPLETE_UPLOAD_DESIGN_CART: ' complete_upload_design_cart',
  REPLACE_DESIGN: 'replace_design',
  INVALID_CART_MODAL: 'invalid_cart_modal',
  EDITOR_TO_CHECKOUT: 'editor_to_checkout',
  EDITOR_TO_PREVIEW: 'editor_to_preview',
  EDITOR_TO_ADD_TO_CART: 'editor_to_add_to_cart',
  PREVIEW_TO_CHECKOUT: 'preview_to_checkout',
  PREVIEW_TO_CART: 'preview_to_cart',
  PREVIEW_TO_CONTINUE_DESIGN: 'preview_to_continue_design'
}


export const EVENT_LABELS = {
  CART_PAGE: 'cart_page',
  PRODUCT_PAGE: 'product_page',
  EDITOR_PAGE: 'editor_page',
  SHARE_IN_IMAGE: 'share_in_image',
  SHARE_DIALOG: 'share_dialog',
  SHARE_IN_DIALOG: 'share_in_dialog',
  SHARE_IN_EDIT_DISPLAY: 'share_in_editDisplay',
  ONBOARDING_START_DIALOG: 'onboarding_start_dialog',
  LOGO_TEXT_ADD_CENTER: 'logo_text_add_center',
  LOGO_TEXT_ADD_LEFT_TOP: 'logo_text_add_leftTop',
  COLOR_PATTERN_CHANGE: 'color_pattern_change',
  EDIT_PATTERN_CHANGE: 'edit_pattern_change',
  TEXT_CHANGE: 'text_change',
  DESIGN_PREVIEW_OPEN: 'design_preview_open',
  DESIGN_PC_SHARE: 'design_pc_share',
  PC_SECOND_COLUMN_UPPER: 'pc_second_column_upper',
  PC_SECOND_COLUMN_LOWER: 'pc_second_column_lower',
  MOBILE_SECOND_COLUMN_UPPER: 'mobile_second_column_upper',
  MOBILE_SECOND_COLUMN_LOWER: 'mobile_second_column_lower',
  PC_THREE_COLUMN_UPPER: 'pc_three_column_upper',
  PC_THREE_COLUMN_LOWER: 'pc_three_column_lower',
  MOBILE_THREE_COLUMN_UPPER: 'mobile_three_column_upper',
  MOBILE_THREE_COLUMN_LOWER: 'mobile_three_column_lower',
  PC_CART_ITEM: 'pc_cart_item',
  MOBILE_CART_ITEM: 'mobile_cart_item'
}

export const BQ_EVENT_NAMES = {
  SEARCH_KEYWORD: 'searchKeyword',
  SEARCH_RESULT_CLICK: 'clickSearchResult',
  CLICK_KEYWORD_SEARCH_SUGGESTION: 'clickKeywordSearchSuggestion',
  CLICK_MERCHANDISE: 'novelty_clickMerchandise',
  VIEW_MERCHANDISE: 'novelty_displayMerchandise'
}

export const BQ_QUERY_NAMES = {
  SEARCH_TRACK_QUERY: 'trackingSearch',
  ClICK_SUGGESTION_QUERY: 'clickSuggest'
}
